/**
 * 塾コード関連メソッド
 */
export default class AcademyCodeUtils {
  /** 使用可能文字 */
  private static ENABLE_CHARACTERS = /^[a-zA-Z0-9\-_]+$/

  /** コード最低長 */
  private static CODE_MIN_LENGTH = 2

  /** コード最大長 */
  private static CODE_MAX_LENGTH = 8

  /**
   * 有効なコード文字列かを判定する
   *
   * @param code コード
   * @returns 有効時：null 無効時：エラーメッセージ
   */
  public static checkCodeEnabled(code: string): string | null {
    if (code.length < this.CODE_MIN_LENGTH) {
      return `塾コードは${this.CODE_MIN_LENGTH}文字以上で入力してください`
    }

    if (code.length > this.CODE_MAX_LENGTH) {
      return `塾コードは${this.CODE_MAX_LENGTH}文字以下で入力してください`
    }

    if (!this.ENABLE_CHARACTERS.test(code)) {
      return '塾コードには半角のアルファベット、数字、ハイフン(-)、アンダーバー(_)のみ使用できます'
    }

    return null
  }
}
